module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/download-6d88a675945e52c96c6839837e70c5cd.svg";